'use strict';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOAPDataSource = void 0;
const crypto = __importStar(require("crypto"));
const graphql_1 = require("graphql");
const soap_1 = require("soap");
const SOAPCache_1 = require("./SOAPCache");
/**
 * A Soap datasource class
 *
 */
class SOAPDataSource {
    /**
     * constructor
     *
     * @param {String} wsdl a wsdl url of a soap service
     *
     */
    constructor(wsdl, config) {
        if (!wsdl) {
            throw new graphql_1.GraphQLError('Cannot make request to SOAP endpoint, missing soap wsdl url.');
        }
        this.wsdl = wsdl;
        this.cache = new SOAPCache_1.SOAPCache(config.cache);
        this.options = {
            wsdl_headers: {},
            wsdl_options: {},
        };
    }
    /**
     * Intercept the request and append client options
     *
     * @param {IOptions} options an object options of
     * [soap](https://www.npmjs.com/package/soap#options) npm module
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    willSendRequest(options) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    /**
     * A callback method to decide the soap response can be cached or not
     *
     * @param {Object} response
     * @return {Boolean} true if cachable or otherwise false.
     */
    shouldCache(response) {
        // by default we will assume response is cachable
        return response ? true : false;
    }
    /**
     * Get a soap client for given wsdl url
     */
    createClient() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.client) {
                    yield this.willSendRequest(this.options);
                    this.client = yield (0, soap_1.createClientAsync)(this.wsdl, this.options);
                    // lets use wsdl_headers for each soap method invocation.
                    if (this.options.wsdl_headers) {
                        Object.keys(this.options.wsdl_headers).forEach((key) => this.client.addHttpHeader(key, this.options.wsdl_headers[key]));
                    }
                    // soap header should be a object with strict xml-string
                    if (this.options.soapHeader) {
                        this.client.addSoapHeader(this.options.soapHeader);
                    }
                }
            }
            catch (error) {
                throw new graphql_1.GraphQLError(error.message);
            }
            return this.client;
        });
    }
    /**
     * Invoke the soap method
     *
     * @param {String} methodName the method name to Invoke
     * @param {Object} params the params for soap method
     * @param {CacheOptions} cacheOptions options for caching
     *
     */
    invoke(methodName, params, cacheOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            try {
                // create the client
                yield this.createClient();
                if (cacheOptions && cacheOptions.ttl > 0) {
                    // caching enabled
                    response = yield this.cache.get(getKey(this.wsdl, methodName, params));
                    if (!response) {
                        const result = yield this.client[methodName + 'Async'](params);
                        response = result[0];
                        if (this.shouldCache(response)) {
                            // store it in cache as well
                            this.cache.put(getKey(this.wsdl, methodName, params), response, cacheOptions.ttl);
                        }
                    }
                }
                else {
                    const result = yield this.client[methodName + 'Async'](params);
                    response = result[0];
                }
            }
            catch (error) {
                throw new graphql_1.GraphQLError(error.message);
            }
            return response;
        });
    }
}
exports.SOAPDataSource = SOAPDataSource;
/**
 * get the key for
 *
 *  @param {String} url wsdl url
 *  @param {String} methodName soap method name
 *  @param {Object} params
 *  @return {String} the hash as key
 */
function getKey(url, methodName, params) {
    const secret = 'SoapSecret';
    if (!params) {
        params = {};
    }
    const hash = crypto
        .createHmac('sha256', secret)
        .update(url + methodName + JSON.stringify(params))
        .digest('hex');
    return hash;
}
